import axios, {AxiosError} from "axios";
import {get, isString} from "lodash";
import {useCallback, useEffect} from "react";
import {toast} from "sonner";
import {urls} from "routes/urls";
import {axiosFlexInstance, axiosSpringInstance} from "./BackofficeApiManager";
import {useNavigate} from "react-router-dom";

const BackofficeApiExceptionManager = () => {
  const navigate = useNavigate();

  const notificationHandler = useCallback((error: any) => {
    const errorData = get(error, "response.data");
    const detail = get(errorData, "detail");
    const errorMessage = isString(errorData) ? errorData : isString(detail) ? detail : undefined;
    toast.error(errorMessage || "Network connection is lost.");
  }, []);

  const errorHandler = useCallback(
    (error: AxiosError) => {
      if (!axios.isAxiosError(error)) {
        return Promise.reject(error);
      }

      const errorMsg = error.response?.data;
      const errorStatus = error.response?.status;

      if (errorStatus === 401 || errorStatus === 403) {
        if (errorMsg === "Invalid role") {
          return;
        }
        if (errorMsg === "Signature has expired") {
          navigate(urls.backofficeLogin.url);
          return;
        }
      }

      const isCancel = axios.isCancel(error);
      if (isCancel) {
        return Promise.reject(error);
      }

      notificationHandler(error);
      return Promise.reject(error);
    },
    [notificationHandler]
  );

  useEffect(() => {
    axiosFlexInstance.interceptors.response.use(undefined, (error) => errorHandler(error));
    axiosSpringInstance.interceptors.response.use(undefined, (error) => errorHandler(error));
  }, []);

  return null;
};

export default BackofficeApiExceptionManager;
